import { createPlugin, PluginDef } from '@fullcalendar/core';
import { formatWithCmdStr } from './format';

export default createPlugin({
  name: '<%= dayjs-fullcalendar-plugin %>',
  cmdFormatter: formatWithCmdStr
}) as PluginDef;
export { toDayjs, toDayjsDuration } from './convert';
